<template> 
  <div
    class="overlay z-30"
    tabindex="0"
  >
    <div
      class="dialog bet-list-dialog divide-y"
      style="max-width: 500px;"
    >
      <div class="dialog-title">
        <div class="flex items-center gap-2">
          <div class="w-40">
            <v-img 
              :src="imagePath(form.item.room.game_id, form.item.room.name)"
            />
          </div>
          <div class="flex flex-col justify-center">
            <span>{{ form.item.room.name }}</span>
            <span class="lotto-date">{{ form.item.created_at | dateOnlyFormat }}</span>
          </div>
        </div>
        <button
          id="back-dialog-btn"
          class="icon"
          type="button"
          @click="close"
        >
          <div class="flex items-center justify-center">
            <svg
              data-v-aee14c88=""
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            ><path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            ></path></svg>
          </div>
        </button>
      </div>
      <div class="dialog-subtitle">
        <div class="flex items-center gap-2 font-sm">
          #{{ form.item.ref_id }}
        </div>
        <span 
          class="font-sm stake-status"
          :class="statusClass(form.data)"
        >
          <!-- {{ form.data.stake_status.name }} -->
          <template v-if="form.data.stake_status.name == 'แทง'">
            รอออกผล
          </template>
          <template v-else>
            {{ form.data.stake_status.name }} 
          </template>
        </span>
      </div>
      <div class="overflow-x-auto h-96 rounded-none">
        <table class="relative w-full">
          <div
            class="w-full"
          >
            <thead class="border-t first:border-t-0">
              <tr>
                <th class="py-1 w-full w-m-a">
                  ประเภท
                </th>
                <th class="py-1 text-right">
                  เลข
                </th>
                <th class="py-1 text-right">
                  แทง
                </th>
                <th class="py-1 text-right">
                  เรทจ่าย
                </th>
                <th class="py-1 text-right w-m-a">
                  ออกผล
                </th>
                <th class="py-1 text-center">
                  ถูกรางวัล
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, i) in dataGroupByNumber(form.data.lists)"
                :key="i"
              >
                <td>
                  <div class="flex items-center gap-1 font-semibold font-sm">
                    {{ (item.number_type || {}).name || '-' }}
                  </div>
                </td>
                <td class="text-right">
                  {{ item.number }}
                </td>
                <td class="px-0 py-2 text-right">
                  {{ item.price_x_unit_amount || '0' }}
                </td>
                <td class="text-right">
                  {{ item.avg_reward_x_unit_amount || '0' | currency }}
                </td>
                <td class="text-right font-sm">
                  <span>{{ item.win_number || 'รอออกผล' }}</span>
                </td>
                <td class="text-right">
                  <span v-if="IsWinStake(item)"> +{{ item.reward_x_unit_amount | currency }} </span>
                  <span v-else>{{ 0 | currency }}</span>
                </td>
              </tr>
            </tbody>
          </div>
        </table>
      </div>

      <div class="dialog-actions member-balance flex items-center justify-space-between gap-2">
        <span class="item-title">ยอดแทง</span>
        <span class="item-value animate-slide-left font-semibold">{{ form.data.bet_amount | currency }}</span>
      </div>
      <div class="dialog-actions bet-amount flex items-center justify-space-between gap-2">
        <span class="item-title">ถูกรางวัล</span>
        <span class="item-value animate-slide-left font-semibold">{{ form.data.win_amount | currency }}</span>
      </div>
      <div
        v-if="canReturnList (form.item)"
        class="dialog-actions grid grid-cols gap-2"
        @click="removeLotto(form.item)"
      >
        <button
          id="return-btn"
          type="button"
          class="bg-error/10 text-error"
        >
          <div
            class="flex items-center justify-center"
          >
            คืนโพย
          </div>
        </button>
      </div>
      <div class="mt-5"></div>
    </div>
  </div>
</template>
<script>
import { dateConvert } from '@/plugins/time'
import { imagePath } from '@/plugins/mapImage'

export default { 
  components: {
  },
  props:{
    form:{
      type: Object,
      default:()=>{}
    }
  },
  computed : {

  },
  watch:{

  },
  methods: {
    imagePath,
    dateConvert,
    close () {
      this.$emit('close');
    },

    canReturnList (item) {
      return item.stake_status.id === 2 && (dateConvert(item.room.locked_at)>new Date())
    },

    statusClass (item) {

      if (item.stake_status.name == 'แทงไม่ถูก') {
        return 'red-x'
      } else if (item.stake_status.name == 'ยกเลิกโพย') {
        return 'red-x'
      } else if (item.stake_status.name == 'แทง') {
        return 'yellow-x'
      } else if (item.stake_status.name == 'ถูกรางวัล') {
        return 'green'
      }
  
      return 'gray-x'
    },

    removeLotto (item) { 
      this.$ga.event('Button', 'RemoveStakeList', 'StakeListPage','')
      if(dateConvert(item.room.locked_at)>new Date()) {
        this.$emit('remove', item.list_uuid) 
      }
    },
 
    dataGroupByNumber (items) {

      if (!items) {
        return []
      }

      const groupedItems = Object.values(
        items.reduce((acc, item) => {
          const key = `${item.number}_${item.number_type.id}`

          if (!acc[key]) {
            acc[key] = { 
              ...item, 
              avg_reward_x_unit_amount: item.reward_x_unit_amount / item.unit
            };
          } else {
            acc[key].unit += item.unit;
            acc[key].price_x_unit_amount += item.price_x_unit_amount;
            acc[key].reward_x_unit_amount += item.reward_x_unit_amount;
            acc[key].avg_reward_x_unit_amount = acc[key].reward_x_unit_amount / acc[key].unit;
          }

          return acc;
        }, {})
      );

      return groupedItems;
    },

    IsWinStake (item) {
      return (item.stake_status || {}).id===3 
    },

  },  
}
</script>
<style scoped>
.z-30 {
  z-index: 300 !important;
}

.overlay {
  align-items: center;
  background-color: rgba(0, 0, 0, .7);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: .5rem;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 11;
}

.dialog {
  --tw-bg-opacity: 1;
  background-color: rgba(251, 239, 231, var(--tw-bg-opacity));
  border-radius: .5rem;
  display: flex;
}

.dialog {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
  flex-direction: column;
  max-height: 100%;
  text-align: left;
  width: 100%;
  z-index: 30;
}

.dialog .dialog-actions, .dialog .dialog-text, .dialog .dialog-title {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.dialog-title {
  align-items: center;
  color: #1f2937;
  display: flex;
  font-size: 1.2rem;
  font-weight: 600;
  justify-content: space-between;
  line-height: 1.5rem;
  padding: .75rem 1rem;
}

.dialog-subtitle {
  align-items: center;
  color: #1f2937;
  display: flex;
  font-size: 1.2rem;
  font-weight: 600;
  justify-content: space-between;
  line-height: 1.5rem;
  padding: .25rem 1rem;
}

.h-8 {
  height: 2rem !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.bg-slate-400 {
  background-color: rgb(148 163 184/ 1) !important;
}

.bg-amber-400 {
  background-color: rgb(251 191 36/ 1) !important;
}

.bg-emerald-500 {
  background-color: rgb(16 185 129/ 1) !important;
}

.bg-sky-500 {
  background-color: rgb(14 165 233/ 1) !important;
}

.bg-rose-500 {
  background-color: rgb(244 63 94/ 1) !important;
}

.bg-violet-500 {
  background-color: rgb(139 92 246/ 1) !important;
}

table {
  border-collapse: collapse;
  border-color: inherit;
  text-indent: 0;
}

table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

table thead tr th {
  --tw-bg-opacity: 1;
  background-color: rgba(46, 30, 30, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  white-space: nowrap;
  line-height: 1.75rem;
  padding: .5rem;
  text-align: left;
  text-transform: capitalize;
  white-space: nowrap;
}

.btn.icon, [type=button].icon, [type=submit].icon, button.icon {
  height: 2rem;
  min-height: 2rem;
  padding: 0;
  width: 2rem;
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: var(--bg-secondary-color-v2);
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}

.min-w-\[100px\] {
  min-width: 100px !important;
}

table tbody tr:nth-child(2n) {
  background-color: var(--bg-primary-250);
}

.input-group, .select-group .select-button {
  --tw-border-opacity: 1;
  border-color: rgba(var(--color-tertiary), var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(var(--color-background), var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.input-group {
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: .25rem;
  color: #374151;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  position: relative;
  transition: all .2s cubic-bezier(.4,0,.2,1);
}

.btn.text, [type=button].text, [type=submit].text, button.text {
  background-color: transparent;
  box-shadow: none;
}

.error2 {
  color: #000;
}

.error2:hover {
  background-color: var(--bg-primary-550);
  border-radius: .2em;
}

.dialog .dialog-actions {
  font-size: 1.2rem;
  padding: .5rem .75rem;
}

.bet-list-dialog #return-btn {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color:  var(--bg-primary-550);
  font-weight: bold;
  border-style: solid;
}

.bg-error\/10 {
  color: red;
  background-color: rgba(255, 18, 34, .1) !important;
}

table tbody tr td {
  color: #374151;
  font-weight: 500;
  line-height: 1.75rem;
  padding: .5rem;
  white-space: normal;
}

@media (min-width: 640px) {
  table tbody tr td, table thead tr th {
    /* font-weight: 600;font-weight: 600; */
    line-height: 1.5rem;
    padding: .5rem .75rem;
  }
}

.price-input {
   padding: .25rem 1rem;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.btn-confirm {
  gap: 10px;
}

.font-sm {
  font-size: 16px
}

.w-m-a {
  min-width: 90px;
}

.stake-status {
  /* background-color: var(--bg-secondary-color-v2); */
  color: white;
  padding: 2px 4px;
  border-radius: 4px;
}

.w-40 {
  width: 28px;
}

.lotto-date  {
  font-size: 0.925rem;
}

</style>